import type { TermInput, TermKind } from '../../types/billing';

export interface TermDraft {
  plan_id: string; // '' = all modules
  kind: TermKind;
  value: string;
  starts_on: string;
  ends_on: string;
  reason: string;
}

export const emptyTermDraft = (): TermDraft => ({
  plan_id: '', kind: 'discount_percent', value: '', starts_on: '', ends_on: '', reason: '',
});

/** Null when the draft is complete, else the first thing missing. */
export function termDraftProblem(d: TermDraft): string | null {
  if (d.kind === 'free_period' && !d.ends_on) return 'A free period needs an end date';
  if (d.kind === 'discount_percent' && !(Number(d.value) > 0 && Number(d.value) <= 100)) return 'Enter a percentage between 1 and 100';
  if (d.kind === 'discount_fixed' && !(Number(d.value) > 0)) return 'Enter the dollars off per month';
  if (!d.reason.trim()) return 'Give a reason — it is what the next person reads';
  return null;
}

export function termDraftToInput(d: TermDraft): TermInput {
  return {
    plan_id: d.plan_id ? Number(d.plan_id) : null,
    kind: d.kind,
    value: d.kind === 'free_period' ? null : Number(d.value),
    starts_on: d.starts_on || null,
    ends_on: d.ends_on || null,
    reason: d.reason.trim(),
  };
}

